var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning-icon-dark-mode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warning-icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "#FFA585",
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a1 1 0 11-2 0 1 1 0 012 0",
    id: "Fill-5-Copy-2",
    fill: "#FFA585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3a.931.931 0 01.929.997l-.393 5.504a.537.537 0 01-1.072 0l-.393-5.504A.931.931 0 018 3z",
    id: "Rectangle",
    fill: "#FFA585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warning-icon-Copy"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "#F66",
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a1 1 0 11-2 0 1 1 0 012 0",
    id: "Fill-5-Copy-2",
    fill: "#F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3a.931.931 0 01.929.997l-.393 5.504a.537.537 0 01-1.072 0l-.393-5.504A.931.931 0 018 3z",
    id: "Rectangle",
    fill: "#F66"
  })))));
}

SvgWarning.displayName = 'Warning';
export default SvgWarning;